import React from 'react';

const ProductCard = ({ product }) => {
  const getStatusBadge = (status) => {
    const badges = {
      live: { text: 'Live', class: 'status-live' },
      beta: { text: 'Beta', class: 'status-beta' },
      coming: { text: 'Coming Soon', class: 'status-coming' }
    };
    return badges[status] || badges.live;
  };

  const badge = getStatusBadge(product.status);

  return (
    <div className="product-card">
      <div className="product-header">
        <h3>{product.name}</h3>
        <span className={`status-badge ${badge.class}`}>{badge.text}</span>
      </div>
      
      <p className="product-description">{product.description}</p>
      
      <ul className="product-features">
        {product.features.map((feature, index) => (
          <li key={index}>{feature}</li>
        ))}
      </ul>
      
      <div className="product-cta">
        {product.status === 'live' ? (
          <a 
            href={product.url} 
            target="_blank" 
            rel="noopener noreferrer"
            className="btn btn-primary"
          >
            Open
          </a>
        ) : (
          <button className="btn btn-secondary">Request Demo</button>
        )}
      </div>
    </div>
  );
};

export default ProductCard;